import { tracked } from '@glimmer/tracking';

import type DateRange from 'webapp/models-custom/date-range';

// just for the range dropdowns
export default class RangeCategory {
	id: number;
	title: string;
	isDatepicker: boolean;
	@tracked isSingleItem = false;
	@tracked items: DateRange[] = [];

	constructor(id: number, title: string, isDatepicker = false) {
		this.id = id;
		this.title = title;
		this.isDatepicker = !!isDatepicker;
	}
}
